// In development, REACT_APP_API_URL is empty → relative /api/ calls are proxied to localhost:4000 via package.json proxy
// In production, set REACT_APP_API_URL to your backend URL (e.g. https://workstamp.up.railway.app)
const API_BASE = process.env.REACT_APP_API_URL || '';

export default API_BASE;
